'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    if (typeof window === 'undefined') return;
    setTimeout(function () {
        return window.dispatchEvent(new Event('resize'));
    }, 100);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/dom/windowResizeEvent.js
// module id = 661
// module chunks = 0